import apiClient from 'services/_infra/apiClient';
import { loginfo } from 'services/_infra/util/apiUsageLogger';

export async function createFusionUser(
  role,
  base,
  department,
  rank,
  name,
  email,
  employeeId,
  phoneNumber,
  gender,
  birthday,
  address,
  emergencyContact,
  isAdmin,
  isMaintenance,
  maintenanceOperatorLevel,
  serviceManager,
  url = window.location.origin,
  avatar = null,
  widget_list = null,
  user_save = null,
  company_save = null,
) {
  try {
    return await apiClient.post('/fusionCreate', {
      role,
      base,
      department,
      rank,
      name,
      email,
      employeeId,
      phoneNumber,
      gender,
      birthday,
      address,
      emergencyContact,
      isAdmin,
      isMaintenance,
      maintenanceOperatorLevel,
      serviceManager,
      avatar,
      widget_list,
      user_save,
      company_save,
      url,
    });
  } catch (error) {
    console.error('fusionCreate failed.', error);
  }
}

export async function updateUserProfile(phoneNumber, gender, birthday, address, emergencyContact) {
  try {
    return await apiClient.post('/updateFusionUserProfile', {
      phoneNumber,
      gender,
      birthday,
      address,
      emergencyContact,
    });
  } catch (error) {
    console.error('updateFusionUserProfile failed.', error);
  }
}

export async function updateUserProfileByAdmin(
  userId,
  role,
  base,
  department,
  rank,
  name,
  employeeId,
  phoneNumber,
  gender,
  birthday,
  address,
  emergencyContact,
  isAdmin,
  isMaintenance,
  maintenanceOperatorLevel,
  serviceManager,
) {
  try {
    return await apiClient.post('/updateFusionProfileByAdmin', {
      editId: userId,
      role,
      base,
      department,
      rank,
      name,
      employeeId,
      phoneNumber,
      gender,
      birthday,
      address,
      emergencyContact,
      isAdmin,
      isMaintenance,
      maintenanceOperatorLevel,
      serviceManager,
    });
  } catch (error) {
    console.error('updateUserProfileByAdmin failed.', error);
  }
}

export async function getUserProfileInfo(userId = null) {
  try {
    return await apiClient.post('/getFusionUserProfile', { editId: userId });
  } catch (error) {
    console.error('getFusionUserProfile failed.', error);
  }
}

export async function checkFusionUserEmail(email) {
  try {
    return await apiClient.post('/checkFusionUserEmail', { email });
  } catch (error) {
    console.error('checkFusionUserEmail failed.', error);
  }
}

export async function deleteUser(deleteId) {
  try {
    loginfo();
    return await apiClient.post('/deleteUser', { deleteId });
  } catch (error) {
    console.error('deleteUser failed.', error);
  }
}

export async function submitFusionInquiry(name, email, phone, notes) {
  try {
    loginfo();
    return await apiClient.post('/fusionInquiries', {
      name,
      email,
      phone,
      notes,
    });
  } catch (error) {
    console.error('fusionInquiries failed.', error);
  }
}
